import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  Signal,
} from '@angular/core';

import {
  CurrencyComponent,
  getColumnKey,
  TableBodyNoReferenceCellComponent,
  TableColumn,
} from '@web/shared/ui';
import {
  OrderStatusComponent,
  RefundedPriceComponent,
} from '@web/shared/module/shop';
import { isNil, isNotNil } from '@web/utils';
import { Route, RouteParam, RouterLinkParams } from '@web/common';
import { AdminSubscriptionOrderCollectionItem } from '../../models/admin-subscription-order-collection-item';
import { AdminSubscriptionOrderCollectionFilter } from '../../models/admin-subscription-order-collection-filter';
import { AdminSubscriptionOrderTypeComponent } from '../admin-subscription-order-type/admin-subscription-order-type.component';
import { AdminSubscriptionOrderEventBusService } from '../../bus/services/admin-subscription-order-event-bus.service';
import { AdminSubscriptionOrderPreviewBusEvent } from '../../bus/events/admin-subscription-order-preview-bus.event';
import { Tooltip } from 'primeng/tooltip';

@Component({
  selector: 'app-admin-subscription-order-list-custom-cell-template',
  imports: [
    TableBodyNoReferenceCellComponent,
    OrderStatusComponent,
    AdminSubscriptionOrderTypeComponent,
    Tooltip,
    RefundedPriceComponent,
    CurrencyComponent,
  ],
  templateUrl:
    './admin-subscription-order-list-custom-cell-template.component.html',
  styleUrl:
    './admin-subscription-order-list-custom-cell-template.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminSubscriptionOrderListCustomCellTemplateComponent {
  /* prettier-ignore */
  public readonly column = input.required<TableColumn<AdminSubscriptionOrderCollectionItem, AdminSubscriptionOrderCollectionFilter>>();
  /* prettier-ignore */
  public readonly model = input.required<AdminSubscriptionOrderCollectionItem>();

  protected readonly orderDetailsParams = this.orderDetailsParamsSignal();

  /* prettier-ignore */
  protected readonly getColumnKey = getColumnKey<AdminSubscriptionOrderCollectionItem>;
  protected readonly isNotNil = isNotNil;
  protected readonly Route = Route;
  protected readonly isNil = isNil;

  private readonly eventBus = inject(AdminSubscriptionOrderEventBusService);

  public handleShowDetailsClick(): void {
    this.eventBus.publish(
      new AdminSubscriptionOrderPreviewBusEvent({
        orderId: this.model().id,
      }),
    );
  }

  private orderDetailsParamsSignal(): Signal<RouterLinkParams> {
    return computed(() => ({
      [RouteParam.Guid]: this.model().id,
    }));
  }
}
